document.addEventListener('DOMContentLoaded', function () {
	const accordionEls = document.querySelectorAll('.lens-specs__accordion')

	accordionEls.forEach((accordionEl) => {
		const accordionButton = accordionEl.querySelector('.lens-specs__accordion-button')
		if (accordionButton) {
			accordionButton.addEventListener('click', function () {
				accordionEl.classList.toggle('lens-specs__accordion--active')
			})
		}
	})

	// Initialize sliders on button click
	const buttons = document.querySelectorAll('.lens-specs__swatch-button')
	buttons.forEach((button) => {
		button.addEventListener('click', function (event) {
			event.preventDefault()

			// Get the target slider ID
			const targetId = this.getAttribute('id')
			const targetSlider = document.getElementById(targetId)

			console.log(targetSlider)

			// targetSlider.querySelectorAll('img').forEach(img => {
			//     const dataSrc = img.getAttribute('data-src');
			//     if (dataSrc) {
			//         img.setAttribute('src', dataSrc);
			//     }
			// });

			// Hide all sliders and remove lens-specs class
			const allSlideGroups = document.querySelectorAll('.lens-specs__slide-group')
			allSlideGroups.forEach((slideGroup) => {
				slideGroup.classList.remove('lens-specs__slide-group--active')
			})

			// Show the target slider and add active class

			targetSlider.classList.add('lens-specs__slide-group--active')

			// Initialize the target slider if not already initialized
			// if (!sliders[targetId]) {
			//     sliders[targetId] = new Glide(`#${targetId}`, {
			//         // Glide options here
			//     }).mount();
			// }
		})
	})

	// Initialize the first slide group on load
	const firstSlideGroup = document.querySelector('.lens-specs__slide-group')
	if (firstSlideGroup) {
		firstSlideGroup.classList.add('lens-specs__slide-group--active')
		// sliders[firstSlideGroup.id] = new Glide(`#${firstSlideGroup.id}`, {
		//     // Glide options here
		// }).mount();
	}

	const glideElement = document.querySelector('.lens-specs__swatches')
	let glideInstance = null

	function mountGlide() {
		glideInstance = new Glide(glideElement, {
			type: 'slider',
			startAt: 0,
			perView: 1,
			gap: 20,
		})
		glideInstance.mount()

		// Attach resize event listener to the window
		glideInstance.on('resize', handleResize)
	}

	function destroyGlide() {
		if (glideInstance) {
			glideInstance.destroy()
			glideInstance = null
		}
	}

	function handleResize() {
		if (window.innerWidth > 1000) {
			destroyGlide()
			glideElement.classList.add('lens-specs__swatches--disabled')
		} else {
			if (!glideInstance) {
				mountGlide()
			}
			glideElement.classList.remove('lens-specs__swatches--disabled')
		}
	}

	window.addEventListener('resize', handleResize)
	handleResize() // Initial check

	// Initial mount if width is less than or equal to 1400px
	if (window.innerWidth <= 1000) {
		mountGlide()
		glideElement.classList.remove('lens-specs__swatches--disabled')
	}
})

